module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_50.6c575715.png";